<span class="delta">
  <span class="delta__previous">{{previousText}}</span>
  <span class="delta__arrow" [class.delta__arrow--up]="direction === 'up'"
    [class.delta__arrow--down]="direction === 'down'">{{arrow}}</span>
  <span class="delta__current" [style.color]="currentColour">{{currentText}}</span>
  @if (display === 'percent' && delta !== null) {
    <span class="delta__value" [class.delta__value--down]="delta < 0">{{deltaText}}</span>
  }
</span>
